import { isNull, isObject, getFunctionName } from '../utils';

const breakpointsStore = { };

// if you change this value update the return func name below under Breakpoints.match
export const MATCH_BREAKPOINTS = '_$bp';

export const isBreakpointFunction = value => {
  return typeof value == 'function' && getFunctionName(value) === MATCH_BREAKPOINTS;
}

export const breakpointKeysList = ['xs', 'sm', 'md', 'lg', 'xl'];

export function createBreakpoints(value) {
  if (typeof value === 'function' && value.id && breakpointsStore[value.id]) {
    return value;
  }
  const id = JSON.stringify(value);
  const keys = [];
  const breakpoints = { };
  for (const key in value) {
    breakpoints[key] = value[key];
    keys.push(key);
  }
  keys.sort((a, b) => breakpoints[a] - breakpoints[b]);
  const breakpointsFunc = value => {
    if (!isObject(value)) {
      throw new Error(`breakpoints requires an object with one or more size properties set: ${breakpointKeysList}`);
    }
    
    // match this name to the value of MATCH_BREAKPOINTS
    const _$bp = props => {
      return getBreakpointValue(value, { ...props, breakpoints })
    }

    for (const key in value) {
      _$bp[key] = value[key];
    }


    // TODO: make this cleaner
    const minMax = breakpointKeysList.reduce((curr, key) => {
      let min = curr.min;
      let max = curr.max;
      if (value.hasOwnProperty(key)) {
        if (!min) {
          min = key;
        }
        max = key;
      }
      return { min, max };
    }, { min: null, max: null });

    _$bp.maxSize = minMax.max;
    _$bp.minSize = minMax.min;


    return _$bp;
  }
  breakpointsFunc.id = id;
  breakpointsFunc.keys = keys;
  breakpointsFunc.values = breakpoints;
  breakpointsFunc.match = breakpointsFunc;
  // breakpointsFunc.cache = { };
  breakpointsStore[id] = breakpointsFunc;
  return breakpointsFunc;
}

export function getCurrentBreakpoint(props) {
  const { breakpoints, breakpoint } = props;
  if (!breakpoints || !breakpoint ) return null;
  if (typeof breakpoint === 'string') {
    const size = breakpoint;
    const index = breakpoints.keys.indexOf(size);
    if (index === -1) return null;
    return { size, index };
  }
  if (typeof breakpoint === 'object') {
    const { key: size, index } = breakpoint;
    if (!size) return null;
    return { size, index }
  }
  return null;
}

export function getBreakpointValue(value, props) {
  let { breakpoints, theme } = props;
  if (!breakpoints.keys && theme) {
    breakpoints = theme.breakpoints;
  }

  const curr = getCurrentBreakpoint({ ...props, breakpoints });
  if (curr) {
    if (!isNull(value[curr.size])) return value[curr.size];

    for (let i = curr.index; i >= 0; i -= 1) {
      const key = breakpoints.keys[i];
      if (!isNull(value[key])) {
        return value[key];
      }
    }

    if (curr.index !== breakpoints.keys.length - 1) {
      for (let i = curr.index; i < breakpoints.keys.length; i += 1) {
        const key = breakpoints.keys[i];
        if (!isNull(value[key])) {
          return value[key];
        }
      }
    }
  }
  return value;
}
